import React, { useEffect, useState, useRef } from "react";
import { IbanElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { createSEPAPayment } from "../../../apis/paymentAPI";
const SubscriptionInfo = ({ subDetails }) => {
  return (
    <>
      <div className=" mb-3 p-3 bg-body rounded shadow-sm">
        <h3>Payment</h3>
        <h5>Subscription Details</h5>
        <div className="table-striped">
          <table
            className="table table-striped table-hover "
            style={{ marginTop: 25 }}
          >
            <tbody>
              <tr>
                <td>
                  <strong> Seq Number: </strong>
                </td>
                <td>{subDetails.seqNo}</td>
              </tr>
              <tr>
                <td>
                  <strong> Investment Amount: </strong>
                </td>
                <td>{subDetails.investmentAmount}</td>
              </tr>
              <tr>
                <td>
                  <strong> ShareClass Type: </strong>
                </td>
                <td>{subDetails.shareClassType}</td>
              </tr>

              <tr>
                <td>
                  <strong> Funds Received Origin: </strong>
                </td>
                <td>{subDetails.fundsReceivedOrigin}</td>
              </tr>
              <tr>
                <td>
                  <strong> Existing Inv: </strong>
                </td>
                <td>{subDetails.existingInv}</td>
              </tr>
              <tr>
                <td>
                  <strong> Account Holder Name: </strong>
                </td>
                <td>{subDetails.accountHolderName}</td>
              </tr>
              <tr>
                <td>
                  <strong>Confirm Bank Details: </strong>
                </td>
                <td>{subDetails.confirmBankDetails}</td>
              </tr>
              <tr>
                <td>
                  <strong>IBAN: </strong>
                </td>
                <td>{subDetails.iban}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className=" mb-3 p-3 bg-body rounded shadow-sm">
        <div className="table-responsive">
          <h3>Subscribers</h3>
          <table className="table table-striped">
            <thead>
              <tr>
                <th> # </th>
                <th> Name </th>
                <th> Email </th>
              </tr>
            </thead>
            <tbody>
              {subDetails.subscribers &&
                subDetails.subscribers.map((sub, index) => (
                  <tr key={index}>
                    <td> {index + 1} </td>
                    <td>
                      {" "}
                      {` ${sub.title} ${sub.firstName} ${sub.lastName}`}{" "}
                    </td>
                    <td> {sub.email} </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SubscriptionInfo;
